<template>
    <svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   id="Message_And_Communication_Icons"
   style="enable-background:new 0 0 50 50;"
   version="1.1"
   viewBox="0 0 50 50"
   xml:space="preserve"
   sodipodi:docname="iconfinder_Icon_Moving_Cloud_Save_3319440.svg"
   inkscape:version="0.92.3 (2405546, 2018-03-11)"><metadata
     id="metadata1201"><rdf:RDF><cc:Work
         rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" /><dc:title></dc:title></cc:Work></rdf:RDF></metadata><defs
     id="defs1199" /><sodipodi:namedview
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1"
     objecttolerance="10"
     gridtolerance="10"
     guidetolerance="10"
     inkscape:pageopacity="0"
     inkscape:pageshadow="2"
     inkscape:window-width="1920"
     inkscape:window-height="1017"
     id="namedview1197"
     showgrid="false"
     showguides="true"
     inkscape:guide-bbox="true"
     inkscape:zoom="9.44"
     inkscape:cx="23.202466"
     inkscape:cy="26.836027"
     inkscape:window-x="1912"
     inkscape:window-y="-8"
     inkscape:window-maximized="1"
     inkscape:current-layer="g1166"><sodipodi:guide
       position="22.677604,26.347967"
       orientation="1,0"
       id="guide1748"
       inkscape:locked="false" /><sodipodi:guide
       position="30.786111,27.621359"
       orientation="0,1"
       id="guide1750"
       inkscape:locked="false" /><sodipodi:guide
       position="38.688629,25.748724"
       orientation="1,0"
       id="guide1752"
       inkscape:locked="false" /><sodipodi:guide
       position="35.055718,11.27326"
       orientation="0,1"
       id="guide1754"
       inkscape:locked="false" /><sodipodi:guide
       position="39.903337,25.748146"
       orientation="1,0"
       id="guide1806"
       inkscape:locked="false" /></sodipodi:namedview><g
     id="g1194"><g
       id="g1140"
       transform="translate(0,-4)"><g
         id="g1114"><g
           id="g1080"><g
             id="g1078"><path
               d="m 35.1,20.6 -0.8,-0.9 c 1.4,-1.2 3.2,-1.8 5,-1.8 v 1.2 c -1.5,0 -3,0.5 -4.2,1.5 z"
               style="fill:#0d5fc3"
               id="path1076"
               inkscape:connector-curvature="0" /></g></g><g
           id="g1086"><g
             id="g1084"><path
               d="m 33.8,23.6 -1.1,-0.5 c 0.3,-0.6 0.6,-1.2 1.1,-1.8 l 0.9,0.8 c -0.4,0.5 -0.7,1 -0.9,1.5 z"
               style="fill:#4de0f9"
               id="path1082"
               inkscape:connector-curvature="0" /></g></g><g
           id="g1092"><g
             id="g1090"><path
               d="m 33.2,23.1 -1.1,-0.5 c 0.3,-0.6 0.6,-1.2 1.1,-1.8 l 0.9,0.8 c -0.4,0.5 -0.7,1 -0.9,1.5 z"
               style="fill:#0d5fc3"
               id="path1088"
               inkscape:connector-curvature="0" /></g></g><g
           id="g1106"><g
             id="g1098"><g
               id="g1096"><path
                 d="m 36.6,17.7 c 0.3,0 0.6,-0.1 1,-0.1 0.2,0 0.5,0 0.7,0 -1.1,-1.6 -2.5,-2.8 -4.2,-3.6 1,1.1 1.9,2.3 2.5,3.7 z"
                 style="fill:#4de0f9"
                 id="path1094"
                 inkscape:connector-curvature="0" /></g></g><g
             id="g1104"><g
               id="g1102"><path
                 d="m 42.9,19.9 c 1.3,1.3 2,3.1 2,5.1 0,1 -0.2,1.9 -0.5,2.8 h -5.1 c 0,0.1 0,0.2 0,0.4 0,0.5 0.1,1 0.2,1.4 H 47 c 0.3,-0.9 0.5,-1.8 0.5,-2.8 0.1,-3.2 -1.9,-5.9 -4.6,-6.9 z"
                 style="fill:#4de0f9"
                 id="path1100"
                 inkscape:connector-curvature="0" /></g></g></g><g
           id="g1112"><g
             id="g1110"><path
               d="M 46.5,29.2 H 41.2 V 28 h 4.5 c 0.2,-0.7 0.4,-1.4 0.4,-2.2 0,-3.7 -3,-6.7 -6.7,-6.7 -0.3,0 -0.6,0 -0.9,0.1 H 38 l -0.2,-0.4 c -1.6,-3.7 -5.1,-6 -9.1,-6 -4.9,0 -9.1,3.7 -9.8,8.5 l -0.1,0.5 h -0.5 c -2.8,0.2 -5,2.6 -5,5.4 0,0.3 0,0.5 0.1,0.8 h 5 v 1.2 h -6 l -0.1,-0.5 c -0.1,-0.5 -0.2,-1 -0.2,-1.6 0,-3.3 2.4,-6 5.6,-6.5 1,-5.2 5.6,-9.1 10.9,-9.1 4.3,0 8.2,2.5 10,6.3 0.2,0 0.4,0 0.6,0 4.4,0 7.9,3.6 7.9,7.9 0,1 -0.2,2 -0.6,3 z"
               style="fill:#0d5fc3"
               id="path1108"
               inkscape:connector-curvature="0" /></g></g></g><g
         id="g1120"><g
           id="g1118"><rect
             height="1.2"
             style="fill:#0d5fc3"
             width="11.3"
             x="4.4000001"
             y="28"
             id="rect1116" /></g></g><g
         id="g1126"><g
           id="g1124"><rect
             height="1.2"
             style="fill:#0d5fc3"
             width="4.8000002"
             x="8.3000002"
             y="24.700001"
             id="rect1122" /></g></g><g
         id="g1132"><g
           id="g1130"><rect
             height="1.2"
             style="fill:#0d5fc3"
             width="3.5999999"
             x="12.1"
             y="21.4"
             id="rect1128" /></g></g><g
         id="g1138"><g
           id="g1136"><rect
             height="1.2"
             style="fill:#0d5fc3"
             width="2.7"
             x="8.6999998"
             y="17.9"
             id="rect1134" /></g></g></g><g
       id="g1192"><g
         id="g1166"><g
           id="g1146"
           transform="translate(-7.6293945e-7,1.7069369)"><g
             id="g1144"><rect
               height="2.3"
               style="fill:#4de0f9"
               width="9.5"
               x="30.700001"
               y="35.5"
               id="rect1142" /></g></g><g
           id="g1152"
           transform="matrix(1,0,0,1.5158751,0,-17.793142)"><g
             id="g1150"><polygon
               points="40.2,37.8 37.7,37.8 37.7,28.5 40.2,26.9 "
               style="fill:#4de0f9"
               id="polygon1148"
               transform="matrix(1,0,0,0.94697628,0,2.0042964)" /></g></g><g
           id="g1158"
           transform="matrix(1,0,0,1.4946421,0,-16.514445)"><g
             id="g1156"><path
               d="M 39.918726,36.959473 H 21.5 V 25.3 h 16.156075 l 2.247262,1.576736 z M 22.7,36.2 h 16 l -0.0057,-5.089164 -0.0057,-3.884574 -1.705048,-1.20459 H 22.677605 Z"
               style="fill:#0d5fc3"
               id="path1154"
               inkscape:connector-curvature="0"
               sodipodi:nodetypes="ccccccccccccc" /></g></g><rect
           style="opacity:1;fill:#4de0f9;fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:0;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:markers fill stroke"
           id="rect1746-3"
           width="4.9080505"
           height="2.0768356"
           x="27.061867"
           y="26.649612" /><rect
           style="opacity:1;fill:#4de0f9;fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:0;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:markers fill stroke"
           id="rect1746-3-9"
           width="1.8095336"
           height="2.7124262"
           x="30.160383"
           y="26.014021" /><path
           style="opacity:1;fill:#0d5fc3;fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:0;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:markers fill stroke"
           d="M 23.931641 24.195312 L 23.931641 27.939453 L 31.648438 27.939453 L 31.648438 24.195312 L 23.931641 24.195312 z M 24.947266 25.210938 L 30.507812 25.210938 L 30.507812 26.933594 L 24.947266 26.933594 L 24.947266 25.210938 z "
           id="rect1746" /><ellipse
           style="opacity:1;fill:#4de0f9;fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:0;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:markers fill stroke"
           id="path1771"
           cx="31.382416"
           cy="33.368645"
           rx="2.0391948"
           ry="2.0656779" /><ellipse
           style="opacity:1;fill:#0d5fc3;fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:0;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:markers fill stroke"
           id="path1771-4"
           cx="30.932205"
           cy="33.050846"
           rx="2.0391948"
           ry="2.0656779" /></g><g
         id="g1172"
         transform="translate(0,-4)"><g
           id="g1170"><rect
             height="1.2"
             style="fill:#0d5fc3"
             width="2.2"
             x="19.9"
             y="30.6"
             id="rect1168" /></g></g><g
         id="g1178"
         transform="translate(0,-4)"><g
           id="g1176"><rect
             height="1.2"
             style="fill:#0d5fc3"
             width="5.5999999"
             x="16.5"
             y="33.400002"
             id="rect1174" /></g></g><g
         id="g1184"
         transform="translate(0,-4)"><g
           id="g1182"><rect
             height="1.2"
             style="fill:#0d5fc3"
             width="9"
             x="13.1"
             y="36.200001"
             id="rect1180" /></g></g><g
         id="g1190"
         transform="translate(0,-4)"><g
           id="g1188"><rect
             height="1.2"
             style="fill:#0d5fc3"
             width="1.6"
             x="15.8"
             y="14.5"
             id="rect1186" /></g></g></g></g></svg>
</template>
<script>
// https://www.iconfinder.com/iconsets/message-and-communication-sets
export default {

};
</script>
